import { useRef } from 'react';
import Applicant from "./Applicant";

const Applicants = ({page, formData, setFormData, setValidationErrors}) => {
    const applicant1Ref = useRef();
    const applicant2Ref = useRef();
    const applicant3Ref = useRef();
    const applicant4Ref = useRef();
    const applicant5Ref = useRef();
    const applicant6Ref = useRef();

    function handleRelevance(applicantRef, i, isRelevant) {
        applicantRef.current.style.display = isRelevant ? 'block' : 'none';

        document.getElementById('applicant_' + i + '_name').required = isRelevant;
        document.getElementById('applicant_' + i + '_gender').required = isRelevant;
        document.getElementById('applicant_' + i + '_relationship').required = isRelevant;
        document.getElementById('applicant_' + i + '_address_auto').required = isRelevant && formData['applicant_' + i + '_lives_with'] === 'No';
        document.getElementById('applicant_' + i + '_address').required = isRelevant && formData['applicant_' + i + '_lives_with'] === 'No';
        document.getElementById('applicant_' + i + '_city').required = isRelevant && formData['applicant_' + i + '_lives_with'] === 'No';
        document.getElementById('applicant_' + i + '_state').required = isRelevant && formData['applicant_' + i + '_lives_with'] === 'No';
        document.getElementById('applicant_' + i + '_zip').required = isRelevant && formData['applicant_' + i + '_lives_with'] === 'No';
        document.getElementById('applicant_' + i + '_county').required = isRelevant && formData['applicant_' + i + '_lives_with'] === 'No';
        Array.from(applicantRef.current.getElementsByClassName('DateInput')).forEach(element => {
            element.required = isRelevant;
        });

    };

    function handleOthers(event) {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));

        handleRelevance(applicant1Ref, 1, value > 0);
        handleRelevance(applicant2Ref, 2, value > 1);
        handleRelevance(applicant3Ref, 3, value > 2);
        handleRelevance(applicant4Ref, 4, value > 3);
        handleRelevance(applicant5Ref, 5, value > 4);
        handleRelevance(applicant6Ref, 6, value > 5);
        
        //reset defaults
        if (value < 6) {
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_name: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_dob: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_has_ssn: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_ssn: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_gender: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_relationship: 'Child' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_lives_with: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_currently_enrolled: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_will_expire: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_offer_through_job: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_filing_jointly: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_is_dependent: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_address_auto: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_address: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_address2: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_city: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_state: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_zip: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_6_county: '' }));
        }
        if (value < 5) {
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_name: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_dob: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_has_ssn: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_ssn: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_gender: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_relationship: 'Child' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_lives_with: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_currently_enrolled: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_will_expire: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_offer_through_job: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_filing_jointly: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_is_dependent: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_address_auto: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_address: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_address2: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_city: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_state: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_zip: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_5_county: '' }));
        }
        if (value < 4) {
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_name: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_dob: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_has_ssn: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_ssn: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_gender: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_relationship: 'Child' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_lives_with: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_currently_enrolled: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_will_expire: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_offer_through_job: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_filing_jointly: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_is_dependent: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_address_auto: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_address: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_address2: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_city: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_state: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_zip: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_4_county: '' }));
        }
        if (value < 3) {
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_name: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_dob: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_has_ssn: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_ssn: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_gender: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_relationship: 'Child' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_lives_with: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_currently_enrolled: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_will_expire: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_offer_through_job: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_filing_jointly: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_is_dependent: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_address_auto: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_address: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_address2: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_city: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_state: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_zip: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_3_county: '' }));
        }
        if (value < 2) {
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_name: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_dob: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_has_ssn: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_ssn: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_gender: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_relationship: 'Child' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_lives_with: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_currently_enrolled: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_will_expire: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_offer_through_job: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_filing_jointly: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_is_dependent: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_address_auto: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_address: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_address2: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_city: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_state: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_zip: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_2_county: '' }));
        }
        if (value < 1) {
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_name: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_dob: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_has_ssn: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_ssn: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_gender: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_relationship: 'Spouse' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_lives_with: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_currently_enrolled: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_will_expire: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_offer_through_job: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_filing_jointly: 'Yes' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_is_dependent: 'No' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_address_auto: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_address: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_address2: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_city: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_state: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_zip: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, applicant_1_county: '' }));
        }
    };

    return (
        <div>
            <div className="QuestionBox">
                <label className="QuestionLabel" htmlFor="how_many_others">How many others will be on this policy?</label>
                <div className="QuestionSubtext">Please include everyone else you want to have coverage in addition to {formData.applicant_name.split(' ')[0]}.</div>
                <select className="QuestionInput" id="how_many_others" name="how_many_others" value={formData.how_many_others} onChange={handleOthers}>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                </select>
            </div>
            <Applicant page={page} applicantRef={applicant1Ref} i={1} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <Applicant page={page} applicantRef={applicant2Ref} i={2} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <Applicant page={page} applicantRef={applicant3Ref} i={3} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <Applicant page={page} applicantRef={applicant4Ref} i={4} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <Applicant page={page} applicantRef={applicant5Ref} i={5} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <Applicant page={page} applicantRef={applicant6Ref} i={6} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
        </div>
    );
};

export default Applicants;